module.exports = __webpack_public_path__ + "img/dropdown_arrow_down_blue.00b86654.svg";